import React from 'react';

interface LegalEntityDetailsProps {
  className?: string;
  /** Nagłówek sekcji. Domyślnie „Dane rejestrowe Fundacji". */
  title?: string;
}

type Detail = { label: string; value: React.ReactNode };

/**
 * Dane rejestrowe Fundacji „Znajdki" (KRS, NIP, REGON, forma prawna,
 * reprezentacja, sąd rejestrowy). Wspólny blok używany na stronach prawnych.
 */
const DETAILS: Detail[] = [
  { label: 'Pełna nazwa', value: 'Fundacja „Znajdki"' },
  { label: 'Forma prawna', value: 'Fundacja' },
  { label: 'Status', value: 'Aktywna' },
  { label: 'KRS', value: '0000437387' },
  { label: 'NIP', value: '1132860384' },
  { label: 'REGON', value: '146390781' },
  {
    label: 'Adres siedziby',
    value: 'ul. Leona Berensona 90, 03-287 Warszawa, woj. mazowieckie',
  },
  { label: 'Reprezentacja', value: 'Zarząd Fundacji' },
  { label: 'Sposób reprezentacji', value: 'Każdy członek zarządu samodzielnie' },
  {
    label: 'Sąd rejestrowy',
    value:
      'Sąd Rejonowy dla m.st. Warszawy w Warszawie, XIV Wydział Gospodarczy Krajowego Rejestru Sądowego',
  },
  { label: 'Sygnatura', value: 'WA.XIV NS-REJ.KRS/21046/23/786' },
];

export function LegalEntityDetails({
  className = '',
  title = 'Dane rejestrowe Fundacji',
}: LegalEntityDetailsProps) {
  return (
    <div
      className={`bg-accessible-gray-50 dark:bg-accessible-gray-700 high-contrast:bg-black p-6 rounded-lg ${className}`.trim()}
    >
      <h2 className="heading-4 mb-3">{title}</h2>
      <dl className="space-y-2">
        {DETAILS.map(({ label, value }) => (
          <div key={label} className="flex flex-col sm:flex-row sm:gap-4">
            <dt className="body-medium font-semibold no-margin sm:w-56 sm:flex-shrink-0">
              {label}
            </dt>
            <dd className="body-medium no-margin">{value}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
